import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import { useHistory, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../Constants/ApiConstants";

const SubscriptionEdit = () => {
    let history = useHistory();
    const {id} = useParams();
    const [subscription, setSubscription] = useState({
        minimum_packet_count: "",
        per_packet:"",
        tentative_price:"",
        description:""
    });
  
    const { minimum_packet_count,per_packet,tentative_price,description } = subscription;
    const onInputChange = e => {
      setSubscription({ ...subscription, [e.target.name]: e.target.value });
    };

    console.log(subscription)
  

  useEffect(() => {
    loadSubscription();
  }, []);
  
    const onSubmit = async e => {
      e.preventDefault();
      await axios.post(`${API_BASE_URL}/v1/subscription/edit/${id}`, subscription).then(response => { 
        console.log("Response:",response.data.message)
        toast.success(response.data.message);

    }).catch(error => {
        console.log(error.response.data.message)
        toast.error(error.response.data.message);
    });
      //history.push("/subscriptions");
    };
  
    const loadSubscription = async () => {
      const result = await axios.get(`${API_BASE_URL}/v1/subscription/${id}`);
      setSubscription(result.data.data);
    };
    
    return (
        <div class="w-full h-screen overflow-x-hidden border-t flex flex-col">
        <ToastContainer />
        <main class="w-full flex-grow p-6">
            <h1 class="w-full text-3xl text-black pb-6">Update Subscription</h1>
            <div className="flex flex-wrap">
                <div className="w-full  my-6 pr-0 lg:pr-2">
                    <p className="text-xl pb-6 flex items-center">
                        <i className="fas fa-list mr-3"></i> Enter Information
                    </p>
                    <div className="leading-loose">
                        <form className="p-10 bg-white rounded shadow-xl" onSubmit={e => onSubmit(e)}>
                            <div className="">
                                <label className="block text-sm text-gray-600" for="name">Minimum Packet Count</label>
                                <input className="w-full px-5 py-1 text-gray-700 bg-gray-200 rounded" id="name"
                                    name="minimum_packet_count"
                                    value={minimum_packet_count}
                                    onChange={e => onInputChange(e)}
                                    type="text" required="true" placeholder="(ex:3)" aria-label="Name" />
                            </div>
                    
                            <div className="mt-2">
                                <label className="block text-sm text-gray-600" for="price">Per Packet Chicken</label>
                                <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="price"
                                    name="per_packet"
                                    value={per_packet}
                                    onChange={e => onInputChange(e)}
                                    type="text" required="true" placeholder="(ex:2)" aria-label="price" />
                            </div>

                            <div className="mt-2">
                                <label className="block text-sm text-gray-600" for="price">Tentative Price</label>
                                <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="price"
                                    name="tentative_price"
                                    value={tentative_price}
                                    onChange={e => onInputChange(e)}
                                    type="text" required="true" placeholder="(ex:2)" aria-label="price" />
                            </div>

                            <div className="mt-2">
                                <label className="block text-sm text-gray-600" for="price">Description</label>
                                <input className="w-full px-5  py-4 text-gray-700 bg-gray-200 rounded" id="price"
                                    name="description"
                                    value={description}
                                    onChange={e => onInputChange(e)}
                                    type="text" required="true" placeholder="(ex:2)" aria-label="price" />
                            </div>

                            <div className="mt-6">
                                <button className="px-4 py-1 text-white font-light tracking-wider bg-gray-900 rounded" type="submit">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>

    </div>
    )
}

export default SubscriptionEdit
